import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfigService } from './app-config.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CafeMenuNamesListRequestBody, CafeMenuNamesListResponse } from '../Models/cafe-menu-name';

@Injectable({
  providedIn: 'root',
})
export class CafeMenuNamesService {
  OBPortalSvcURL = '';
  headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  constructor(
    private appConfigService: AppConfigService,
    private httpClient: HttpClient) {
      this.OBPortalSvcURL = this.appConfigService.OBPortalSvcURL;
  }

  public getCafeMenuNames(slnshpid: number | undefined,ltyname: string | undefined): Observable<CafeMenuNamesListResponse> {
    const cafeMenuNamesInfo = new CafeMenuNamesListRequestBody(slnshpid, ltyname);

    return this.httpClient.post<CafeMenuNamesListResponse>(`${this.OBPortalSvcURL}GetCafeMenuNames`, cafeMenuNamesInfo, { headers: this.headers });
  }
}
